export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/8df8849227212e4621cd836c576a9b5d.jpg"
          alt="Professional Music Studio in Tumahole Parys - Master Jae Production Recording Equipment"
          title="Master Jae Production Studio - Recording Mixing Mastering"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-[#0a0f1c]/70 to-[#0a0f1c]"></div>
      </div>

      {/* Animated Sound Wave Visualization */}
      <div className="absolute inset-0 flex items-center justify-center opacity-20">
        <div className="flex items-center space-x-1">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="w-1 bg-[#00d9ff] rounded-full animate-pulse"
              style={{
                height: `${Math.random() * 100 + 20}px`,
                animationDelay: `${i * 0.05}s`,
                animationDuration: `${Math.random() * 1 + 0.5}s`
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-black tracking-tight mb-4">
            <span className="text-white block">YOUR VISION,</span>
            <span className="bg-gradient-to-r from-[#00d9ff] to-[#ff6b35] bg-clip-text text-transparent block">
              PROFESSIONALLY CRAFTED.
            </span>
          </h1>
          <p className="text-gray-300 text-lg md:text-xl mt-6 font-light tracking-wide">
            <strong>Multimedia Production Studio</strong> | Tumahole, Parys
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mt-12">
          <button 
            onClick={() => scrollToSection('contact')}
            className="group bg-black border-2 border-[#ff6b35] text-white px-8 py-4 rounded-full hover:bg-[#ff6b35] transition-all duration-300 font-semibold flex items-center space-x-3 whitespace-nowrap cursor-pointer"
            aria-label="Book a recording session at Master Jae Production"
          >
            <div className="w-10 h-10 rounded-full bg-[#ff6b35] flex items-center justify-center group-hover:bg-white transition-colors duration-300">
              <i className="ri-mic-line text-white group-hover:text-[#ff6b35] text-lg"></i>
            </div>
            <span>BOOK A SESSION</span>
            <i className="ri-arrow-right-line"></i>
          </button>

          <button 
            onClick={() => scrollToSection('portfolio')}
            className="bg-transparent border-2 border-[#00d9ff] text-[#00d9ff] px-8 py-4 rounded-full hover:bg-[#00d9ff] hover:text-black transition-all duration-300 font-semibold whitespace-nowrap cursor-pointer"
            aria-label="View Master Jae Production portfolio"
          >
            VIEW PORTFOLIO
          </button>

          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-[#ff6b35] text-black px-8 py-4 rounded-full hover:bg-[#ff8555] transition-all duration-300 font-semibold flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            aria-label="Request a quote for music production or graphic design"
          >
            <span>REQUEST QUOTE</span>
            <i className="ri-arrow-right-up-line"></i>
          </button>
        </div>
      </div>

      {/* Bottom Anchor Text */}
      <div className="absolute bottom-12 left-0 right-0 overflow-hidden">
        <div className="text-center text-[#ffffff] text-6xl md:text-8xl lg:text-9xl font-black tracking-widest opacity-10">
          MUSIC • DESIGN • POST PRODUCTION
        </div>
      </div>
    </section>
  );
}
